/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerplacementbottomleft3Inputs */

const en_flyerplacementbottomleft3 = /** @type {(inputs: Flyerplacementbottomleft3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom left`)
};

const de_flyerplacementbottomleft3 = /** @type {(inputs: Flyerplacementbottomleft3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unten links`)
};

/**
* | output |
* | --- |
* | "Bottom left" |
*
* @param {Flyerplacementbottomleft3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerplacementbottomleft3 = /** @type {((inputs?: Flyerplacementbottomleft3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerplacementbottomleft3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerplacementbottomleft3(inputs)
	return de_flyerplacementbottomleft3(inputs)
});
export { flyerplacementbottomleft3 as "flyerPlacementBottomLeft" }